// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"702":"a20e9cab","946":"3c7ead37"}[chunkId] + ".css";
};